import { Icon, IconName, IconProps } from '@/shared/uikit/Icon';

import { BFC } from '../types';

// mimeType | fileExtension
export type FileTypeIconProps = Omit<IconProps, 'name'> & ({ type: string } | { ext: string });

const defaultIcon = 'file-text';
const hasType = (info: { ext: string } | { type: string }): info is { type: string } => {
  // eslint-disable-next-line no-prototype-builtins
  return info.hasOwnProperty('type');
};

export const FileTypeIcon: BFC<FileTypeIconProps> = ({ style, size, ...props }) => {
  const name = hasType(props) ? getNameByType(props.type) : getNameByExt(props.ext.slice(0));

  return <Icon name={name} size={size} style={style} />;
};

const typeToNameMap: Record<string, IconName> = {
  'image/jpg': 'file-jpg',
  'image/jpeg': 'file-jpg',
  'image/png': 'file-png',
  'image/heif': 'file-image',
  'image/heic': 'file-image',
  'image/tiff': 'file-image',
  'text/plain': 'file-txt',
  'application/pdf': 'file-pdf',
  'application/msword': 'file-doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'file-doc',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'file-xls',
};

const extToNameMap: Record<string, IconName> = {
  jpeg: 'file-jpg',
  jpg: 'file-jpg',
  pdf: 'file-pdf',
  png: 'file-png',
  svg: 'file-svg',
  txt: 'file-txt',
  doc: 'file-doc',
  docx: 'file-doc',
};

const getNameByType = (type: string) => typeToNameMap[type] ?? defaultIcon;
const getNameByExt = (ext: string) => extToNameMap[ext] ?? defaultIcon;
